// src/components/FeedbackWidget.js
import React, { useState } from 'react';
import { sendFeedbackSafe } from '../../api/ai';

export default function FeedbackWidget({ message, getToken }) {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState('');
  const [showComment, setShowComment] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  // فقط برای پیام‌های دستیار که محتوا دارند
  if (submitted || message.role !== 'assistant' || !message.content) return null;

  const responseId = message.response_id || message.id;

  const handleRate = async (r) => {
    setRating(r);
    setShowComment(true);
    setError(null);

    if (!responseId) {
      setError('امکان ارسال بازخورد برای این پاسخ وجود ندارد.');
      return;
    }

    try {
      const token = getToken();
      if (!token) throw new Error('401');

      await sendFeedbackSafe({
        token,
        response_id: responseId,
        rating: r,
        comment,
        user_query: message.user_query || '',
        response_text: message.content || '',
      });

      setSubmitted(true);
    } catch (e) {
      if (e.message === '401') {
        setError('نشست شما منقضی شده است. لطفاً مجدداً وارد شوید.');
      } else {
        console.error('Feedback error', e);
        setError('خطا در ثبت بازخورد. لطفاً دوباره تلاش کنید.');
      }
    }
  };

  const handleSubmitComment = () => {
    handleRate(rating);
  };

  return (
    <div className="mt-3 pt-2 border-t border-gray-200">
      <div className="flex items-center gap-2 text-xs text-gray-500">
        <span>آیا این پاسخ مفید بود؟</span>

        <button
          onClick={() => handleRate(5)}
          disabled={rating !== null}
          className={`px-2 py-0.5 rounded transition text-base ${
            rating === 5 ? 'bg-purple-100 text-purple-700' : 'text-gray-400 hover:bg-gray-100 hover:text-gray-600'
          } disabled:opacity-50`}
        >
          👍
        </button>

        <button
          onClick={() => handleRate(1)}
          disabled={rating !== null}
          className={`px-2 py-0.5 rounded transition text-base ${
            rating === 1 ? 'bg-purple-100 text-purple-700' : 'text-gray-400 hover:bg-gray-100 hover:text-gray-600'
          } disabled:opacity-50`}
        >
          👎
        </button>
      </div>

      {error && <p className="text-[10px] text-red-500 mt-2">{error}</p>}

      {showComment && !submitted && (
        <div className="mt-2">
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="توضیح اختیاری ..."
            rows={2}
            className="w-full text-xs p-2 border border-gray-200 rounded-lg resize-none focus:ring-1 focus:ring-purple-400 outline-none"
          />
          <button
            onClick={handleSubmitComment}
            disabled={!comment.trim()}
            className="mt-2 px-4 py-1.5 text-xs bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-300 transition"
          >
            ارسال بازخورد
          </button>
        </div>
      )}

      {submitted && (
        <p className="text-[10px] text-green-600 mt-2">بازخورد شما ثبت شد. متشکریم!</p>
      )}

      {!submitted && !error && (
        <p className="text-[10px] text-gray-400 mt-1">فیدبک شما باعث بهبود کار دستیار هوشمند فرزانه است.</p>
      )}
    </div>
  );
}